import React from "react";
import { GraduationCap, Check, Target } from "lucide-react";
import styles from "./StudentHeroArt.module.css";

/** Ilustración decorativa (flat, sólida) para el hero del student-home. */
const BARS = [46, 68, 54, 82];

const StudentHeroArt: React.FC = () => {
    return (
        <div className={styles.art} aria-hidden="true">
            <span className={`${styles.blob} ${styles.blobA}`} />
            <span className={`${styles.blob} ${styles.blobB}`} />

            <div className={styles.panel}>
                <div className={styles.panelHead}>
                    <span className={styles.panelDot} />
                    <span className={styles.panelLine} />
                </div>
                <div className={styles.bars}>
                    {BARS.map((h, i) => (
                        <span
                            key={i}
                            className={styles.bar}
                            style={
                                {
                                    "--h": `${h}%`,
                                    "--d": `${0.5 + i * 0.12}s`,
                                } as React.CSSProperties
                            }
                        />
                    ))}
                </div>
            </div>

            <div className={`${styles.badge} ${styles.badgeCap}`}>
                <GraduationCap size={26} />
            </div>
            <div className={`${styles.badge} ${styles.badgeCheck}`}>
                <Check size={18} />
            </div>
            <div className={`${styles.badge} ${styles.badgeTarget}`}>
                <Target size={20} />
            </div>
        </div>
    );
};

export default StudentHeroArt;
